import {isNullOrUndefined} from "util";

export enum ClientErrorType {
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    INTERNAL_SERVER_ERROR = 500,
    BAD_GATEWAY_ERROR = 502,
    UNEXPECTED_SERVER_ERROR = 9999
}

export function getClientErrorTypeByStatus(status: number) {
    let clientErrorType: ClientErrorType = ClientErrorType[ClientErrorType[status]];

    return isNullOrUndefined(clientErrorType)
        ? ClientErrorType.UNEXPECTED_SERVER_ERROR
        : clientErrorType;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/entity/client.error.type.ts